import cloneDeep from 'lodash/cloneDeep';
export var ComputeId = "compute";
var SD = /** @class */ (function () {
    function SD(sd, name) {
        this.ignoredResourceTypes = [
            'centrify',
            'cronman',
            'cryptor',
            'globaledge',
            'api-gateway',
            'aws-cgp',
            'faila',
            'shipyard',
        ];
        this.sd = cloneDeep(sd);
        this.orgSd = cloneDeep(sd);
        this.serviceName = name;
    }
    SD.prototype.getServiceName = function () {
        return this.serviceName;
    };
    SD.prototype.getSDResources = function () {
        var _this = this;
        if (this.sd.resources !== undefined) {
            return this.sd.resources.filter(function (r) { return !_this.ignoredResourceTypes.includes(r.type); }).map(function (res) {
                var resourceId = "resource-" + res.name;
                return {
                    id: resourceId,
                    type: res.type,
                    displayName: res.name,
                    isCompute: false,
                    sd: res,
                    classifications: (res.attributes && res.attributes.dataType) || [],
                };
            });
        }
        else {
            return [];
        }
    };
    SD.prototype.getSDCompute = function () {
        // Simulate a small section of the service descriptor for compute
        var rawSD = { name: this.sd.name };
        if (this.sd.computeClassification) {
            rawSD = Object.assign(cloneDeep(rawSD), { computeClassification: this.sd.computeClassification });
        }
        // Classifications in the original uploaded service descriptor
        var rawClassifications = (this.sd.computeClassification && this.sd.computeClassification.dataType) || [];
        return {
            id: ComputeId,
            type: "compute",
            displayName: "Compute",
            isCompute: true,
            sd: rawSD,
            classifications: rawClassifications,
        };
    };
    SD.prototype.getResources = function () {
        return [this.getSDCompute()].concat(this.getSDResources()).concat({ id: 'finish', type: 'compute', isCompute: true, displayName: 'Finish & Download', sd: { name: 'finish' }, classifications: [] });
    };
    SD.prototype.getResource = function (resourceId) {
        var res = this.getResources().find(function (r) { return r.id === resourceId; });
        if (!res) {
            throw new Error("resource not found");
        }
        return res;
    };
    SD.prototype.getResourceWithClassifications = function (resourceId, classifications) {
        // No classifications have been set by user -> return the original service descriptor
        var newResource = cloneDeep(this.getResource(resourceId));
        if (!classifications || classifications.length === 0) {
            return newResource;
        }
        // Simulate service descriptor with user selections
        newResource.classifications = classifications;
        if (isResourceCompute(newResource)) {
            if (!newResource.sd.computeClassification) {
                newResource.sd.computeClassification = {};
            }
            newResource.sd.computeClassification.dataType = classifications;
        }
        else {
            if (!newResource.sd.attributes) {
                newResource.sd.attributes = {};
            }
            newResource.sd.attributes.dataType = classifications;
        }
        return newResource;
    };
    SD.prototype.getServiceDescriptor = function () {
        return {
            name: 'serviceDescriptor',
            computeClassification: this.sd.computeClassification,
            resources: this.sd.resources
        };
    };
    SD.prototype.getResourceClassifications = function (overrides) {
        var newMap = cloneDeep(overrides);
        this.getResources().filter(function (r) { return r.id !== 'finish'; }).map(function (r) { newMap[r.id] = r.classifications; });
        // console.log(newMap);
        return newMap;
    };
    SD.prototype.updateAndGetServiceDescriptor = function (resourceId, classifications) {
        var commuteClassification = cloneDeep(this.sd.computeClassification);
        var newSd = cloneDeep(this.orgSd);
        var newResource = this.getResourceWithClassifications(resourceId, classifications);
        if (isResourceCompute(newResource)) {
            var newClassifications = { dataType: classifications };
            commuteClassification = newClassifications;
            newSd.computeClassification = commuteClassification;
        }
        else {
            var resourceName_1 = newResource.displayName;
            var resourcesUpdated = this.sd.resources.map(function (r) {
                var newAttributes = cloneDeep(r.attributes);
                var newResourceSD = r.alarms !== undefined ?
                    { name: r.name, type: r.type, attributes: cloneDeep(r.attributes), alarms: r.alarms } :
                    { name: r.name, type: r.type, attributes: cloneDeep(r.attributes) };
                if (r.name === resourceName_1) {
                    if (newAttributes === undefined) {
                        newAttributes = {};
                    }
                    newAttributes.dataType = classifications;
                    newResourceSD = r.alarms !== undefined ?
                        { name: r.name, type: r.type, attributes: newAttributes, alarms: r.alarms } :
                        { name: r.name, type: r.type, attributes: newAttributes };
                }
                return newResourceSD;
            });
            newSd.resources = resourcesUpdated;
        }
        return newSd;
    };
    return SD;
}());
function isResourceCompute(resource) {
    return resource.isCompute;
}
export default SD;
